jQuery(document).ready(function($) {
	launchVanta($, '.header-default');
  launchVantaSmall($, '#section-values > .container');
  launchVantaSmall($, '#main-footer .vanta-container');
  alignVantaFooter($);
});
 
function launchVanta($, selector) {
  if($(selector).length){
	  VANTA.NET({
      el: selector, 
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minWidth: window.innerWidth,
      minHeight: window.innerHeight,
      scale: 1.00,
      scaleMobile: 1.00,
      color: 0xffffff, 
      backgroundColor: 0x005eb8,
      backgroundAlpha: 1,
      points: 6.00
    }); 
  }
}

function launchVantaSmall($, selector) {
  if($(selector).length){
    VANTA.NET({
      el: selector, 
      mouseControls: false,
      touchControls: false,
      gyroControls: false,
      minWidth: window.innerWidth,
      minHeight: window.innerHeight,
      scale: 1.00,
      scaleMobile: 1.00,
      color: 0x78ADE0, 
      backgroundColor: 0x97D8FF,
      backgroundAlpha: 0,
      points: 3.00
    });
  }
}

function alignVantaFooter($, selector) {
  if($(selector).length){
    var $topCalc = ($(window).innerHeight() - $("#main-footer").height())/-2;
    $("#main-footer .vanta-canvas").css('margin-top', $topCalc);
  }
}